import { httpGet } from './api.service';
import { DeviceType } from '../types/DeviceType';
import { Result } from '../types/Result';

const getDeviceTypes = async (): Promise<Result<DeviceType>> => await httpGet<Result<DeviceType>>(`api/device-type?&skip=0&take=50`);

export { getDeviceTypes };
